import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CDNManager from 'dashboard/CDN/CDNManager';
import Toolbar from '../Toolbar.react';
import styles from '../CDN.scss'
import settingsStyles from 'dashboard/Settings/Settings.scss';

export default class Data extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    CDNManager.CDNServiceCurrentSiteData(this.props.params.cdnId).then((data) => {
      this.setState({
        CDNServiceCurrentSiteData: data,
      })
    });
  }

  saveSettings(data) {
    this.setState({data});
    return Promise.resolve({});
  }

  render() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];
    const props = Object.assign({}, {
      ...this.props,
      CDNServiceCurrentSiteData: this.state.CDNServiceCurrentSiteData || null,
      subsection: this.props.children.props.route.name,
      saveSettings: (r) => this.saveSettings(r),
    });

    let toolBarProps = Object.assign({}, { ...props });
    delete toolBarProps['children'];

    return (
      <div className={classes.join(' ')}>
        <Toolbar {...toolBarProps} />
        {React.cloneElement(this.props.children, {...props})}
      </div>
    );
  }
};